import React from 'react';
import { View } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { ActionDock, PrimaryButton, SecondaryButton } from '../../design/components';

import { createPickListDetailStyles } from './PickListDetail.styles';

// Docked tub card: current tub weight, totals and the exclusion shortcuts.
const PickListTubWeightDock = ({
	tubWeightDisplay,
	tubWeightExcludedSummary,
	lastPickedProductAction,
	lastPickedProductSummary,
	hasExclusionSummaries,
	loadingTubWeightExclusions,
	onExcludeLast,
	onEditLastExclusion,
	onOpenExclusions,
}) => {
	const styles = useThemedStyles(createPickListDetailStyles);

	return (
		<ActionDock>
			<View style={styles.tubWeightTopRow}>
				<Text
					style={[
						styles.tubWeightTitle,
						tubWeightDisplay.showTubPromptStyle ? styles.tubWeightTitlePrompt : null,
					]}
				>
					Tub {tubWeightDisplay.displayTubIndex}
				</Text>
				<Text style={styles.tubWeightValue}>
					{tubWeightDisplay.displayTubProductKg} / {tubWeightDisplay.displaySuggestedTubProductKg} kg picked
				</Text>
			</View>
			<Text style={styles.tubWeightSubText}>
				Tub total {tubWeightDisplay.displayTubTotalKg} / {tubWeightDisplay.maxTubTotalKg} kg incl. tub · Products total {tubWeightDisplay.pickedTotalProductKg} / {tubWeightDisplay.requiredTotalProductKg} kg
				{tubWeightDisplay.requiredTubCount > 0 ? ` · Suggested ${tubWeightDisplay.requiredTubCount} ${tubWeightDisplay.requiredTubCount === 1 ? 'tub' : 'tubs'}` : ''}
			</Text>
			{
				tubWeightDisplay.missingWeightLineCount > 0 && (
					<Text style={styles.tubWeightWarningText}>
						Missing weights: {tubWeightDisplay.missingWeightLineCount} item(s) (totals may be undercounted)
					</Text>
				)
			}
			{
				tubWeightExcludedSummary.excludedQuantity > 0 && (
					<Text style={styles.tubWeightSubText}>
						Excluded from tub weight: {tubWeightExcludedSummary.excludedQuantity} qty across {tubWeightExcludedSummary.excludedProductsCount} product(s)
					</Text>
				)
			}
			<View style={styles.tubWeightActionsRow}>
				<SecondaryButton
					style={styles.tubWeightAction}
					variant="tonal"
					label={lastPickedProductAction?.quantity
						? `Exclude last (+${lastPickedProductAction.quantity})`
						: 'Exclude last'}
					accessibilityHint="Long press to edit the excluded quantity"
					disabled={!lastPickedProductSummary || !lastPickedProductAction?.quantity || loadingTubWeightExclusions}
					onPress={onExcludeLast}
					onLongPress={onEditLastExclusion}
				/>
				<PrimaryButton
					style={styles.tubWeightAction}
					size="compact"
					label="Edit exclusions"
					disabled={!hasExclusionSummaries}
					onPress={onOpenExclusions}
				/>
			</View>
		</ActionDock>
	);
};

export default PickListTubWeightDock;
